export enum ProviderAssignmentAnalyticsEvents {
  PROVIDER_ASSIGNMENT_INITIATED_INQUIRY = 'Provider Assignment Initiated Inquiry',
  PROVIDER_ASSIGNMENT_NO_RECOMMENDED_MATCHES = 'Provider Assignment No Recommended Matches',
  PROVIDER_ASSIGNMENT_NO_MATCHES = 'Provider Assignment No Matches',
  PROVIDER_ASSIGNMENT_NO_INTAKE_AVAILABILITY = 'Provider Assignment No Intake Availability',
  /** @todo Fire when intake duration changed (no UI yet) */
  PROVIDER_ASSIGNMENT_DURATION_SELECTION = 'Provider Assignment Duration Selection',
  PROVIDER_ASSIGNMENT_PROVIDER_SELECTED = 'Provider Assignment Provider Selected',
  PROVIDER_ASSIGNMENT_INTAKE_SLOT_SELECTED = 'Provider Assignment Intake Slot Selected',
  /** @todo Fire when attendee selection changes (planned feature) */
  PROVIDER_ASSIGNMENT_ATTENDEE_SELECTION = 'Provider Assignment Attendee Selection',
  /** @todo Fire when "Assign without scheduling" is clicked (planned feature) */
  PROVIDER_ASSIGNMENT_ASSIGN_WITHOUT_INTAKE = 'Provider Assignment Assign Without Intake',
  PROVIDER_ASSIGNMENT_BACK_NAVIGATED = 'Provider Assignment Back Navigated',
  /** @todo Fire when contact support is clicked (planned feature) */
  PROVIDER_ASSIGNMENT_CONTACT_SUPPORT_CLICKED = 'Provider Assignment Contact Support Clicked',
  PROVIDER_ASSIGNMENT_STEP_VIEWED = 'Provider Assignment Step Viewed',
  PROVIDER_ASSIGNMENT_SUBMISSION = 'Provider Assignment Submission',
  PROVIDER_ASSIGNMENT_SUBMISSION_FAILURE = 'Provider Assignment Submission Failure',
  PROVIDER_ASSIGNMENT_ABANDONED = 'Provider Assignment Abandoned',
  PROVIDER_ASSIGNMENT_COMPLETED = 'Provider Assignment Completed',
  PROVIDER_ASSIGNMENT_FOLLOW_UP_SCHEDULING_COMPLETED = 'Provider Assignment Follow Up Scheduling Completed',
}
